var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 18.835H16.6673",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.574 3.55081L12.1919 2.93289C13.2157 1.90909 14.8757 1.90909 15.8995 2.93289C16.9233 3.95669 16.9233 5.61661 15.8995 6.64041L15.2815 7.25833M11.574 3.55081C11.574 3.55081 11.6513 4.86389 12.8099 6.02249C13.9685 7.18109 15.2815 7.25833 15.2815 7.25833M11.574 3.55081L5.8932 9.23164C5.50843 9.61641 5.31604 9.8088 5.15058 10.0209C4.95541 10.2712 4.78807 10.5419 4.65155 10.8284C4.53581 11.0712 4.44977 11.3294 4.27769 11.8456L3.54852 14.0331M15.2815 7.25833L9.60072 12.9392C9.21594 13.3239 9.02356 13.5163 8.81143 13.6818C8.5612 13.8769 8.29045 14.0443 8.00397 14.1808C7.76111 14.2965 7.503 14.3826 6.98677 14.5547L4.79926 15.2838M4.79926 15.2838L4.26455 15.4621C4.0105 15.5468 3.73042 15.4806 3.54107 15.2913C3.35172 15.1019 3.2856 14.8219 3.37028 14.5678L3.54852 14.0331M4.79926 15.2838L3.54852 14.0331",
    stroke: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleEdit);
export default __webpack_public_path__ + "static/media/PurpleEdit.ec0fc7b664c062140eb58c915529ec38.svg";
export { ForwardRef as ReactComponent };